import React from 'react'

function AroundYou() {
  return (
    <div className='flex flex-1 flex-col h-full justify-center items-center '>
      <img src={'https://media.tenor.com/z1PWcjnX9pkAAAAM/yea.gif'} alt={'cat'} 
      className='w-1/4 my-32'/>
    </div>
  )
}

export default AroundYou